import React, { useState } from 'react';
// @ts-ignore
import YouTube from 'react-youtube';
import { Row, Col } from 'reactstrap';

type IYoutubePlayer = {
  videoIds: string[];
};

const YoutubePlayer: React.FC<IYoutubePlayer> = ({ videoIds }) => {
  const [showVideo, setShowVideo] = useState<boolean>(false);

  const [selectedId, setSelectedId] = useState<string>(videoIds[0]);

  const startVideo = () => {
    setShowVideo(true);
  };
  const opts = {
    frameborder: 0,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      mute: 0,
      controls: 1,
      modestbranding: 1
    }
  };

  return (
    <>
      <Row className="mb-5">
        <Col>
          <div className="content-wrapper youtube-player-wrapper">
            <div
              className={`embed-responsive embed-responsive-16by9${showVideo ? '' : ' play-layer'} bg-black`}
              onClick={() => !showVideo && startVideo()}
            >
              {showVideo ? (
                <YouTube
                  videoId={selectedId}
                  opts={opts}
                  // onError={}
                  className="embed-responsive-item"
                />
              ) : (
                <img
                  className="embed-responsive-item play-layer"
                  style={{ objectFit: 'cover' }}
                  src={`https://img.youtube.com/vi/${selectedId}/0.jpg`}
                  alt="Miniatura filmu"
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      {videoIds.length > 1 && (
        <Row className="mb-5 youtube-player-preview-row">
          {videoIds.map(id => (
            <Col md="4" key={id}>
              <div
                className="youtube-player-preview embed-responsive embed-responsive-16by9 play-layer mb-4"
                onClick={() => setSelectedId(id)}
              >
                <img
                  onClick={() => setSelectedId(id)}
                  className="embed-responsive-item play-layer"
                  style={{ objectFit: 'cover' }}
                  src={`https://img.youtube.com/vi/${id}/0.jpg`}
                  alt="Miniatura filmu"
                />
              </div>
            </Col>
          ))}
        </Row>
      )}
    </>
  );
};

export default YoutubePlayer;
